<div *ngIf="loading || longStoryData === undefined" class="article-long-story-section article-long-story-section-skeleton h-100">
    <div class="article-long-story-skeleton">
        <div class="my-4">
            <div class="w-100 paragraph-line-skeleton skeleton-placeholder"></div>
            <div class="w-100 paragraph-line-skeleton skeleton-placeholder"></div>
            <div class="w-100 paragraph-line-skeleton skeleton-placeholder"></div>
            <div class="w-25 paragraph-line-skeleton skeleton-placeholder"></div>
        </div>
        <div class="my-4">
            <div class="w-100 paragraph-line-skeleton skeleton-placeholder"></div>
            <div class="w-100 paragraph-line-skeleton skeleton-placeholder"></div>
            <div class="w-75 paragraph-line-skeleton skeleton-placeholder"></div>
        </div>
        <div class="my-4">
            <div class="w-100 paragraph-line-skeleton skeleton-placeholder"></div>
            <div class="w-100 paragraph-line-skeleton skeleton-placeholder"></div>
            <div class="w-50 paragraph-line-skeleton skeleton-placeholder"></div>
        </div>
        <div class="my-4">
            <div class="w-100 paragraph-line-skeleton skeleton-placeholder"></div>
            <div class="w-100 paragraph-line-skeleton skeleton-placeholder"></div>
            <div class="w-100 paragraph-line-skeleton skeleton-placeholder"></div>
            <div class="w-25 paragraph-line-skeleton skeleton-placeholder"></div>
        </div>
        <div class="my-4">
            <div class="w-100 paragraph-line-skeleton skeleton-placeholder"></div>
            <div class="w-100 paragraph-line-skeleton skeleton-placeholder"></div>
            <div class="w-75 paragraph-line-skeleton skeleton-placeholder"></div>
        </div>
        <div class="my-4">
            <div class="w-100 paragraph-line-skeleton skeleton-placeholder"></div>
            <div class="w-100 paragraph-line-skeleton skeleton-placeholder"></div>
            <div class="w-100 paragraph-line-skeleton skeleton-placeholder"></div>
            <div class="w-25 paragraph-line-skeleton skeleton-placeholder"></div>
        </div>
        <div
            *ngIf="!displayFailmessage"
            class="d-flex"
            [ngClass]="{ 'highlight-loader': !isMobile && !gyanTypeGyan, 'highlight-loader-gyan': !isMobile && gyanTypeGyan, 'highlight-loader-mobile': isMobile }"
        >
            <div [ngClass]="{ 'mp-gyan': !isMobile && gyanTypeGyan }"><img src="./../../../assets/gifs/loader_sand.gif" alt="Processing icon" /></div>
            <div class="padding-summary">{{ loaderMessage }}</div>
        </div>
        <div class="no-articles-found-gyan" *ngIf="displayFailmessage">
            {{ loaderMessage }}
        </div>
    </div>
</div>

<div *ngIf="!loading && longStoryData !== undefined" class="article-long-story-section">
    <div class="article-long-story">
        <ng-scrollbar>
            <div id="longStoryContentContainer" [attr.data-test]="'longStoryContentContainer'" [innerHTML]="getSafeHtml(longStoryData)"></div>
        </ng-scrollbar>
    </div>
</div>
